var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"simple-infographic-card"},[_c('div',{staticClass:"simple-infographic-card-label"},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"simple-infographic-card-content"},[_c('div',{staticClass:"simple-infographic-card-icon",style:({
        backgroundColor: _vm.iconBackgroundColor
      })},[_c('svg-loader',{style:({
          color: _vm.highlightColor
        }),attrs:{"src":_vm.iconSrc}})],1),_vm._v(" "),_c('div',{staticClass:"simple-infographic-card-value",style:({
        color: _vm.highlightColor
      })},[_vm._v("\n      "+_vm._s(_vm.value)+"\n    ")])])])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }